import { z } from 'zod'
import { oc } from '@orpc/contract'
import { DISCOVERY_KINDS } from '../facility-discovery-shared.schema'
import { enrichmentViewSchema } from './facility-discovery-search.contract'

// Poll target while cards show "checking…". Comma-separated place ids (query string).
// Exported (not inlined into .input()) so handlers can type their parsed
// `input.placeIds` (string[]) directly from this schema's inferred output —
// `HandlerInput<'facilityDiscoveryEnrichment'>` resolves to the pre-transform
// wire shape (`{ placeIds: string }`) because it derives from the contract's
// input *type* rather than its parsed output. See
// facility-discovery-enrichment.handler.ts.
export const facilityDiscoveryEnrichmentInputSchema = z.object({
  placeIds: z
    .string()
    .transform((s) => [
      ...new Set(
        s
          .split(',')
          .map((x) => x.trim())
          .filter(Boolean),
      ),
    ])
    .pipe(z.array(z.string()).min(1).max(40)),
  // The poll has to report the same way the search did. A lab search masks an AI
  // status it can never resolve, and without the kind here the poll would answer
  // with the real one and put the spinner straight back on the row.
  kind: z.enum(DISCOVERY_KINDS).optional(),
})

export const facilityDiscoveryEnrichment = oc
  .route({ method: 'GET', path: '/v2/facility-discovery/enrichment' })
  .input(facilityDiscoveryEnrichmentInputSchema)
  .output(z.object({ items: z.record(z.string(), enrichmentViewSchema) }))
